<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-15 14:36:21
-->
<template>
    <div>
        <a-form 
            ref="formRef"
            :layout="form.layout? form.layout : 'horizontal'"
            label-align="right"
            :label-col-props="form.labelColProps"
            :wrapper-col-props="form.wrapperColProps"
        >
            <div v-for="(item,index) in form.formField" :key="index" :style="{'display':inline-block, 'margin-left':item.margin == undefined? '0px' : item.marginLeft}" >
                <div v-if="item.show == undefined? true : item.show">
                    <!-- 前插文本 -->
                    <a-form-item
                        style="margin-bottom:5px"
                        v-if="item.showItemPreText"
                    >
                        <slot name="itemPreText" :props="{ item }"></slot>
                    </a-form-item>
                    <!-- 单行文本 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        :class="{'noLabel':item.isChild}" 
                        v-if="item.type === 'input'" 
                        :required="item.required"
                        :help="item.helpMsg"
                        :validate-status="item.validateStatus"
                    >
                        <a-input 
                            v-model="form.formData[`${item.key}`]" 
                            :style="{'width':item.width? item.width : '250px' }"
                            :class="{'childInputClass':item.isChild}"
                            :placeholder="item.placeholder? $t(item.placeholder) : ''" 
                            :disabled="item.disabled"
                            :allowClear="item.allowClear"
                            :show-word-limit="item.showWordLimit"
                            :max-length="item.maxLength"
                            @change="(val,ev)=>handleInputChange(item,val)"
                            @input="(val,ev)=>handleInput(item,val)"
                            @blur="()=>handleBlur(item)"
                            @press-enter="()=>handlePressEnter(val,item)"
                            @clear="()=>handleInputClear(val,item)" 
                        >
                            <template #prefix v-if="item.prefix">€</template>
                            <template #suffix v-if="item.suffix">{{ item.suffixText }}</template>
                        </a-input>
                        <slot name="formInput" :props="{ item }" v-if="item.questionIcon">
                            <a-tooltip :content="item.tipToLocale? $t(item.tips) : item.tips"  position="right">
                                <icon-question-circle size="20" style="margin-left:10px"/>
                            </a-tooltip>
                        </slot>
                        <slot name="formInputEditAmount" :props="{ item }" v-if="item.editAmount"></slot>
                    </a-form-item>
                    <!-- 多行文本 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        :class="{'noLabel':item.isChild}" 
                        v-if="item.type === 'textarea'" 
                        :required="item.required"
                        :help="item.helpMsg"
                        :validate-status="item.validateStatus"
                    >
                        <a-textarea 
                            v-model="form.formData[`${item.key}`]" 
                            :style="{'width':item.width? item.width : '250px' }"
                            :class="{'childInputClass':item.isChild}"
                            :placeholder="item.placeholder? $t(item.placeholder) : ''" 
                            :allow-clear="item.allowClear"
                            :disabled="item.disabled"
                            :show-word-limit="item.showWordLimit"
                            :max-length="item.maxLength"
                            auto-size
                            @change="(val,ev)=>handleInputChange(item,val)"
                            @blur="()=>handleBlur(item)"
                        />
                        <slot name="formInput" :props="{ item }" v-if="item.questionIcon">
                            <a-tooltip :content="item.tips"  position="right">
                                <icon-question-circle size="20" style="margin-left:10px"/>
                            </a-tooltip>
                        </slot>
                    </a-form-item>
                    <!-- 单选下拉 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'select'" 
                        :required="item.required"
                    >
                        <a-select
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :disabled="item.disabled"
                            :multiple="item.multiple"
                            :allowClear="item.allowClear"
                            :placeholder="item.placeholder? $t(item.placeholder) : ''" 
                            :loading="item.loading? item.loading : false"
                            allow-search
                            @change="(val,opt)=>handleSelectChange(val,opt,item)"
                            @search="(val)=>handleFetchSearch(val,item)"
                        >
                            <a-option 
                                v-for="(opt,oIndex) in item.options" 
                                :key="oIndex" 
                                :value="opt.value"
                                :disabled="opt.disabled"
                            >
                                {{ item.optionToLocale? $t(opt.label) : opt.label}}
                            </a-option>
                        </a-select>
                        <slot name="formSelect" :props="{ item }">
                            <a-tooltip :content="item.tips"  position="right"  v-if="item.questionIcon">
                                <icon-question-circle size="20" style="margin-left:10px"/>
                            </a-tooltip>
                        </slot>
                        <slot name="formSelectAddIcon" :props="{ item }"></slot>
                    </a-form-item>
                    <!-- 数字输入框 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'inputNumber'" 
                        :required="item.required"
                        :help="item.helpMasg"
                        :validate-status="item.validateStatus"
                    >
                        <a-input-number 
                            v-model="form.formData[`${item.key}`]" 
                            :style="{'width':item.width? item.width : '250px' }"
                            :min="item.min" 
                            :max="item.max" 
                            :precision="item.precision == undefined? null : item.precision"
                            :hide-button="item.hideButton? item.hideButton : false"
                            :disabled="item.disabled"
                            :error="item.error"
                            :placeholder="item.placeholder? $t(item.placeholder) : ''" 
                            @change="(val,ev)=>handleInputNumberChange(item,val)"
                            @input="(val,inputVal,ev)=>handleInputNumber(item,val,inputVal)"
                            @keydown="(ev)=>handleKeydown(ev)"
                        >   
                            <template #prefix v-if="item.prefix">€</template>
                            <template #suffix v-if="item.suffix">{{ item.suffixText }}</template>
                        </a-input-number>
                        <slot name="formInputNumber" :props="{ item }" v-if="item.questionIcon">
                            <a-tooltip :content="item.tips"  position="right">
                                <icon-question-circle size="20" style="margin-left:10px"/>
                            </a-tooltip>
                        </slot>
                    </a-form-item>
                    <!-- 日期时间 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'date'" 
                        :required="item.required"
                    >
                        <a-date-picker 
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :picker="item.picker" 
                            :show-time="item.showTime == undefined? true : showTime"
                            :disabled="item.disabled"
                            :format="item.format"
                            :allowClear="item.allowClear"
                            :value-format="item.valueFormat"
                            :disabledDate="item.disabledDate === undefined || item.disabledDate === false? null : (current) => setDisabledDate(current, item.disabledDateType? item.disabledDateType : '')"
                            @change="(val,date)=>handleDateChange(val,date,item)"
                            @select="(val,date)=>handleSelectDate(val,date,item)"
                        />
                    </a-form-item>
                    <!-- 日期时间2 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'date2'" 
                        :required="item.required"
                    >
                        <a-date-picker 
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :picker="item.picker" 
                            :show-time="item.showTime == undefined? true : showTime"
                            :disabled="item.disabled"
                            :format="item.format"
                            :allowClear="item.allowClear"
                            :value-format="item.valueFormat"
                            :disabledDate="item.disabledDate === undefined || item.disabledDate === false? null : (current) => setDisabledDate2(current)"
                            @change="(val,date)=>handleDateChange(val,date,item)"
                            @select="(val,date)=>handleSelectDate(val,date,item)"
                        />
                    </a-form-item>
                    <!-- 日期范围 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'dateRange'" 
                        :required="item.required"
                        :style="{'margin-left': item.marginLeft}"
                    >
                        <a-range-picker 
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :picker="item.picker" 
                            :allowClear="item.allowClear"
                            :value-format="item.valueFormat"
                            :placeholder="item.placeholder1? [$t(item.placeholder1), $t(item.placeholder2)] : ''" 
                            :disabledDate="item.disabledDate === undefined || item.disabledDate === false? null : (current) => setDisabledDate(current)"
                            @change="(val,date)=>handlePickerDateChange(val,date,item)"
                            @clear="(val)=>handlePickDateClear(val,item)"
                        />
                    </a-form-item>
                    <!-- 周日期 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'weekDate'" 
                        :required="item.required"
                        :style="{'margin-left': item.marginLeft}"
                    >
                        <a-week-picker
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :allowClear="item.allowClear"
                            :disabled="item.disabled"
                            format="wo"
                            day-start-of-week="1"
                            @change="(val,date)=>handleWeekPickerChange(val,date,item)"
                            @clear="(val)=>handleWeekPickClear(val,item)"
                        />
                    </a-form-item>
                    <!-- 年日期 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'yearDate'" 
                        :required="item.required"
                        :style="{'margin-left': item.marginLeft}"
                    >
                        <a-year-picker 
                            v-model="form.formData[`${item.key}`]"
                            :style="{'width': item.width? item.width : '250px'}"
                            :allowClear="item.allowClear"
                            :disabled="item.disabled"
                            format="YYYY"
                            @change="(val,date)=>handleYearPickerChange(val,date,item)"
                            @clear="(val)=>handleYearPickClear(val,item)"
                        />
                    </a-form-item>
                    
                    <!-- switch -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'switch'" 
                        :required="item.required"
                        :disabled="item.disabled? item.disabled : false"
                        :style="{'margin-left': item.marginLeft}"
                    >
                        <a-switch v-model="form.formData[`${item.key}`]" @change="handleChangeSwitch">
                            <template #checked-icon>
                                <icon-check/>
                            </template>
                            <template #unchecked-icon>
                                <icon-close/>
                            </template>
                        </a-switch>
                    </a-form-item>

                    <!-- radio -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'radio'" 
                        :required="item.required"
                        :disabled="item.disabled"
                        :style="{'margin-left': item.marginLeft}"
                        @change="(val)=>changeRadio(val,item)"
                    >
                        <a-radio-group v-model="form.formData[`${item.key}`]">
                            <a-radio 
                                v-for="(i,idx) in item.radioData"
                                :key="idx"
                                :value="i.value"
                                style="margin-right:30px"
                            >
                                {{ $t(i.label) }}
                            </a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <!-- 上传文件 -->
                    <a-form-item 
                        :label="item.name? $t(item.name) : ''" 
                        :label-col-style="form.labelColStyle? {width: form.labelColStyle} : '110px'"
                        v-if="item.type === 'upload'" 
                        :required="item.required"
                        :style="{'margin-left': item.marginLeft}"
                    >
                        <a-upload 
                            :headers="headers" 
                            :action="action"
                            :file-list="item.fileList"
                            :multiple="item.multiple != undefined? item.multiple : false"
                            :limit="item.limit !== undefined? item.limit : 0"
                            @change="(fileList,fileItem)=>handleUploadChange(fileList,fileItem)"
                            @success="(fileItem)=>handleUploadSuccess(fileItem)"
                            @error="(fileItem)=>handleUploadError(fileItem)"
                        />
                        <slot name="uploadFileType"></slot>
                    </a-form-item>

                    <!-- 后插文本 -->
                    <a-form-item
                        style="margin-top:5px"
                        v-if="item.showItemAfterText"
                    >
                        <slot name="itemAfterText" :props="{ item }"></slot>
                    </a-form-item>
                </div>
            </div>
            <a-form-item :label-col-style="{width: form.labelColStyle? form.labelColStyle : '100px'}" v-if="form.showSlot? form.showSlot : false">
                <slot name="formBtn"></slot>
            </a-form-item>
        </a-form>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import dayjs from 'dayjs';
    import { dateToTimestamp, timestampToDate, getNowDate} from '@/utils/index.js';

    const props = defineProps({
        form:{
            type:Object,
            default:()=>{}
        }
    })

    const action = ref(import.meta.env.VITE_BASE_URL + '/order/module/upload/file')
    const headers = ref({
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
    })

    const emits = defineEmits([
        'handleInputChange',
        'handleInput',
        'handleSelectChange',
        'handleFetchSearch',
        'handleBlur',
        'handleInputNumberChange',
        'handleInputNumber',
        'handlePressEnter',
        'handleInputClear',
        'handleDateChange',
        'handlePickerDateChange',
        'handlePickDateClear',
        'handleWeekPickerChange',
        'handleWeekPickClear',
        'handleYearPickerChange',
        'handleYearPickClear',
        'handleChangeSwitch',
        'handleBeforeUpload',
        'handleUploadChange',
        'handleUploadSuccess',
        'handleUploadError',
        'handleSelectDate',
        'changeRadio',
        'handleKeydown',
    ])

    const handleInputChange = (item,val)=>{
        emits('handleInputChange', item, val)
    }

    const handleInput = (item,val)=>{
        emits('handleInput', item, val)
    }

    const handleSelectChange = (val,opt,item)=>{
        // console.log(val,opt,item.key,'val,opt,item')
        emits('handleSelectChange', val,opt,item.key)
    }

    const handleFetchSearch = (val,item)=>{
        emits('handleFetchSearch', val,item.key)
    }

    const handleBlur = (item)=>{
        emits('handleBlur',item)
    }

    const handleInputNumberChange = (item,val)=>{
        emits('handleInputNumberChange',item,val)
    }

    const handleInputNumber = (item,val,inputVal)=>{
        emits('handleInputNumber',item,val,inputVal)
    }

    const handleKeydown = (ev)=>{
        console.log(ev,'handleKeydown')
        emits('handleKeydown',ev.keyCode)
    }

    const handlePressEnter = (val,item)=>{
        console.log(val,item,'handlePressEnter')
        emits('handlePressEnter',val, item)
    }

    const handleInputClear = (val,item)=>{
        console.log(val,item,'handleInputClear')
        emits('handleInputClear',val, item)
    }

    // 
    const handleSelectDate = (val,date,item)=>{
        // console.log(val,'||||',date,'select',item)
        emits('handleSelectDate',val, date, item)
    }

    const handleDateChange = (val,date,item) => {
        // console.log(val,date,item,'handleDateChange')
        emits('handleDateChange',val, item)
    }

    const handlePickerDateChange = (val,date,item)=>{
        console.log(val,date,item,'handlePickerDateChange')
        emits('handlePickerDateChange',val, item)
    }

    const handlePickDateClear = (val,item)=>{
        console.log(val,item,'handlePickDateClear')
        emits('handlePickDateClear',val, item)
    }

    const handleWeekPickerChange = (val,date,item)=>{
        console.log(val,'#',date,item,'handleWeekPickerChange')
        emits('handleWeekPickerChange',val, item)
    }

    const handleWeekPickClear = (val,item)=>{
        console.log(val,item,'handleWeekPickClear')
        emits('handleWeekPickClear',val, item)
    }

    const handleYearPickerChange = (val,date,item)=>{
        console.log(val,'#',date,item,'handleYearPickerChange')
        emits('handleYearPickerChange',val, item)
    }

    const handleYearPickClear = (val,item)=>{
        console.log(val,item,'handleYearPickClear')
        emits('handleYearPickClear',val, item)
    }

    const handleChangeSwitch = (val, item)=>{
        console.log(val,item,'switch')
    }

    const handleBeforeUpload = (fileItem) =>{
        // emits('handleBeforeUpload',fileItem)
    }

    const handleUploadChange = (fileList, fileItem)=>{
        // console.log(fileList, 'fileList', fileItem)
        emits('handleUploadChange',fileList, fileItem)
    }

    const handleUploadSuccess = (fileItem) =>{
        console.log('success', fileItem)
        emits('handleUploadSuccess',fileItem)
    }

    const handleUploadError = (fileItem) =>{
        console.log('error', fileItem)
        emits('handleUploadError',fileItem)
    }

    const changeRadio = (val, item)=>{
        // console.log(val, item,'iiiiii')
        emits('changeRadio',item.key)
    }


    const setDisabledDate = (current, disabledDateType)=>{
        // console.log(current,disabledDateType,'currenttttt',dayjs(current).isBefore(dayjs()))
        let everyDate = timestampToDate(new Date(current).getTime()).split(' ')[0] // 日期组件每天日期
        let prevDate = timestampToDate(new Date(getNowDate()).getTime() - 24 * 60 * 60 * 1000).split(' ')[0] // 当天日期的前一天
        let currentDate = getNowDate() // 当前日期
        let prevDateTime = new Date().getTime() - 24 * 60 * 60 * 1000 // 当前时间前一天的时间戳
        let limitTime = dateToTimestamp(`${prevDate} 11:30:00`) // 限制时间戳
        let everyDateTimestamp = dateToTimestamp(everyDate)

        if(disabledDateType == 'after'){
            if(everyDateTimestamp * 1000 <= prevDateTime){
                return false
            }else{
                return true
            }
        }else{
            if(everyDate == prevDate && prevDateTime < limitTime * 1000 || everyDate == currentDate){ //  当天11:30前，可以选择该天，超过11:30（含11:30）则不能选择该天
                return false
            }else{
                return dayjs(current).isBefore(dayjs())
            }
        }
    }

    const setDisabledDate2 = (current)=>{
        // console.log(current,'currenttttt',dayjs(current).isBefore(dayjs()))
        return dayjs(current).isBefore(dayjs())
    }
    
</script>

<style lang="less" scoped>

</style>